export enum FlightListScope {
	Departures = 'departures',
	Arrivals = 'arrivals',
}
